module.exports = __webpack_public_path__ + "img/somaliland.f3727986.png";